exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-busy[data-v-d875f10a]{color:#e3342f}", ""]);

// exports
